export default __webpack_public_path__ + "static/media/1868.0bf627b2.png";